import React from "react";

import Fade from "react-reveal/Fade";

const LandingPage = () => {
  return (
    <Fade bottom>
      <p>This is the LandingPage! </p>
    </Fade>
  );
};

export default LandingPage;
